<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Sổ sách giảng dạy"
          :link="[
            {
              text: role.type === 'teacher' ? 'Báo cáo chuyên môn' : 'Sổ sách cá nhân của GV',
              href: '../teacher-document',
            },
          ]"
        />
      </div>
      <div class="flex-center" v-if="isEditDocument">
        <v-btn depressed dark color="primary" @click.stop="dialog = true"> Thêm mục </v-btn>
      </div>
    </div>

    <v-card outlined class="mx-4 elevation-0">
      <DocumentTypeDataTable :type="'teacher-document'" />
    </v-card>

    <v-dialog v-model="dialog" scrollable width="700">
      <v-card>
        <v-toolbar color="primary" dense class="elevation-0" dark>
          <v-toolbar-title>Thêm mục</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="title"
              :rules="[$rules.required]"
              label="Tên mục"
              class="required mt-6"
              outlined
              dense
            ></v-text-field>
            <v-textarea v-model="description" label="Mô tả" outlined></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-btn outlined @click="cancel">HUỶ</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">LƯU</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import DocumentTypeDataTable from '@/modules/document/DocumentTypeDataTable.vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    Breadcrumbs,
    DocumentTypeDataTable,
  },
  props: {},
  data() {
    return {
      dialog: false,
      description: '',
      title: '',
    }
  },
  computed: {
    ...mapGetters('auth', ['profile', 'role', 'user', 'isEditDocument']),
    ...mapState('DocumentTypes', ['documentTypes']),
  },
  methods: {
    ...mapActions('DocumentTypes', ['createDocumentType']),
    cancel() {
      this.dialog = false
    },
    async save() {
      if (!this.$refs.form.validate()) return
      try {
        this.$loading.active = true

        const data = {
          type: 'teacher-document',
          title: this.title,
          description: this.description,
          index: this.documentTypes.length + 1,
        }
        await this.createDocumentType(data)

        this.$refs.form.reset()
        this.dialog = false
        this.$alert.addSuccess()
      } catch (error) {
        this.$alert.addError()
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
<style scoped></style>
